import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import login from '@/views/login'
import bgHome from '@/views/baigongfeiyi/bgHome'
import start from '@/views/baigongfeiyi/start'
import chooseRole from '@/views/baigongfeiyi/chooseRole'
import roleDetail from '@/views/baigongfeiyi/roleDetail'
import mathStudy from '@/views/mathStudy'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        level: 0
      }
    },
    {
      path: '/select',
      name: 'select',
      component: () => import('@/views/select')
    },
    {
      path: '/squats',
      name: 'SquatsModel',
      component: () => import('@/views/squats')
    },
    {
      path: '/judge',
      name: 'JudgeModel',
      component: () => import('@/views/judge')
    },
    {
      path: '/oc-jump',
      name: 'ocJump',
      component: () => import('@/views/ocJump')
    },
    {
      path: '/knee-lift',
      name: 'kneeLift',
      component: () => import('@/views/kneeLift')
    },
    {
      path: '/body-flexion',
      name: 'bodyFlexion',
      component: () => import('@/views/bodyFlexion')
    },
    {
      path: '/bend-over',
      name: 'bendOver',
      component: () => import('@/views/bendOver')
    },
    {
      path: '/shoulder',
      name: 'shoulder',
      component: () => import('@/views/shoulder')
    },
    {
      path: '/face',
      name: 'face',
      component: () => import('@/views/face')
    },
    {
      path: '/mp-test',
      name: 'mpText',
      component: () => import('@/views/mpTest')
    },
    {
      path: '/question',
      name: 'question',
      component: () => import('@/views/question')
    },
    {
      path: '/exercise/start',
      name: 'ExerciseStart',
      component: () => import('@/views/exercise/start')
    },
    {
      path: '/exercise/patterns',
      name: 'ExercisePatterns',
      component: () => import('@/views/exercise/patterns')
    },
    {
      path: '/exercise/types',
      name: 'ExerciseTypes',
      component: () => import('@/views/exercise/types')
    },
    {
      path: '/login/',
      name: 'login',
      component: login
    },
    {
      path: '/canvas/',
      name: 'canvas',
      component:  () => import('@/views/canvas')
    }, {
      path: '/baigongfeiyi/bgHome',
      name: 'bgHome',
      component: bgHome,
    },
    { path: '/baigongfeiyi/start', component: start },
    { path: '/baigongfeiyi/chooseRole', component: chooseRole },
    { path: '/baigongfeiyi/roleDetail', component: roleDetail },
    { path: '/mathStudy/', component: mathStudy},
    { path: '/pose-test/', component: () => import('@/views/postTest')}
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: to.meta.savedPosition || 0}
    }
  }
})
